import { loadLang } from '../utils';

export const validations = {
  required: {
    errors: {
      'en-GB': 'Required',
      'it-IT': 'Campo Obbligatorio',
    },
  },
  password: {
    reg: '(?=^.{8,}$)((?!.*\\s)(?=.*[A-Z])(?=.*[a-z]))((?=(.*\\d){1,})(?=(.*\\W){1,}))^.*$',
    errors: {
      'en-GB':
        'Password must be more than 8 characters long, contain at least one uppercase, one lowercase, one digit and a special character.',
      'it-IT':
        'La Password deve avere almeno 8 caratteri, con almeno una lettera maiuscola, una minuscola e un carattere speciale.',
    },
  },
  email: {
    reg:
      '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    errors: {
      'en-GB': 'Email not valid!',
      'it-IT': 'Indirizzo email non valido',
    },
  },
  phonePrefix: {
    reg: '^\\+\\d{1,4}$',
    errors: {
      'en-GB': 'Phone prefix is not valid!',
      'it-IT': 'Prefisso del numero di telefono non valido',
    },
  },
  phoneNumber: {
    reg: '^\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{2,5}$',
    errors: {
      'en-GB': 'Phone number is not valid!',
      'it-IT': 'Numero di telefono non valido',
    },
  },
  numbersOnly: {
    reg: '^[0-9]*$',
    errors: {
      'en-GB': 'Numbers only!',
      'it-IT': 'Solo numeri!',
    },
  },
  dateDay: {
    errors: {
      'en-GB': 'Day not valid!',
      'it-IT': 'Giorno non valido!',
    },
  },
  dateMonth: {
    errors: {
      'en-GB': 'Month not valid!',
      'it-IT': 'Mese non valido!',
    },
  },
  dateYear: {
    errors: {
      'en-GB': 'Year not valid!',
      'it-IT': 'Anno non valido!',
    },
  },
  emailSupported: {
    errors: {
      'en-GB': 'Currently only @qadra.com and @link-me.it emails are supported.',
      'it-IT': 'Al momento solo email @qadra.com e @link-me.it sono supportate.',
    },
  },
};

export const setValidationLocale = (locale) => {
  Object.keys(validations).forEach((k) => {
    validations[k].error = validations[k].errors[locale] || validations[k].errors['en-GB'];
  });
};

setValidationLocale(loadLang() || 'en-GB');

export function validateReg(reg, string) {
  try {
    const re = new RegExp(reg);
    return re.test(string);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return false;
  }
}
